import { SimpleGrid } from '@chakra-ui/react';
import { useFormApi } from '@data-driven-forms/react-form-renderer';

import {
  QUESTION_COLUMN_SCROLL_BUFFER,
  TOP_NAV_HEIGHT,
} from '~/common/components/GlobalLayout/PageLayout/Styled';

type FullPageWithPDFViewerProps = {
  adjustable?: boolean;
  fields?: any[];
  name?: string;
  columns?: number;
  rowSpacing?: string | number;
  columnSpacing?: string | number;
  gridTemplateColumns?: string;
  flexGrow?: number;
  resizerStyle?: any;
  sx?: any;
  children?: React.ReactNode;
  showSplitScreen?: any;
  height?: string;
};

export default function FullPageWithPDFViewer({
  fields = [],
  name,
  columns = 2,
  rowSpacing = 0,
  columnSpacing = 0,
  gridTemplateColumns = '1fr 1fr',
  flexGrow = 1,
  sx,
  children,
  showSplitScreen,
  height,
}: Readonly<FullPageWithPDFViewerProps>) {
  const { renderForm } = useFormApi();
  let isDocumentProvidedValue;

  if (showSplitScreen) {
    try {
      isDocumentProvidedValue = JSON.parse(showSplitScreen);
    } catch {
      isDocumentProvidedValue = false;
    }
  }

  const isSplitView = !!isDocumentProvidedValue;

  // When in split view, make the left column sticky and add a bottom buffer to the questions on the right side
  // This allows the question to scroll partially into the page before the pdf viewer starts to scroll away.
  const splitSx = isSplitView
    ? {
        '& > :first-of-type': {
          position: 'sticky',
          top: 'var(--gl-header-height, 0px)',
          height: `calc(100vh - ${TOP_NAV_HEIGHT} - var(--gl-header-height, 0px))`,
          overflow: 'hidden',
        },
        '& > :last-of-type': {
          marginBottom: QUESTION_COLUMN_SCROLL_BUFFER,
        },
      }
    : {};

  return (
    <SimpleGrid
      id={name}
      data-testid="splitScreenGrid"
      minHeight={height}
      spacingX={columnSpacing}
      spacingY={rowSpacing}
      columns={columns}
      gridTemplateColumns={
        isDocumentProvidedValue === false ? '1fr' : gridTemplateColumns
      }
      flexGrow={flexGrow}
      sx={{ ...splitSx, ...sx }}
    >
      {children ?? renderForm(fields)}
    </SimpleGrid>
  );
}
